// extracted by mini-css-extract-plugin
export default {"button":"Button_button","primary":"Button_primary","secondary":"Button_secondary","tertiary":"Button_tertiary","white":"Button_white","small":"Button_small"};